import React, { useState, useEffect } from "react";
import "./UploadOpportunities.css";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowCircleLeft } from "react-icons/fa";
import { makeAuthenticatedPOSTRequest } from "../../../services/serverHelper";
import { IoClose } from "react-icons/io5";
import indianStatesAndCities from "../../../../data/indian_states_cities";
import AdminNavbar from "../../Navbar/Navbar1";
import AdminSidebar from "../../Navbar/AdminSidebar";
const BASE_URL = process.env.REACT_APP_BASE_URL;

function UploadOpportunities() {
  const location = useLocation();
  const booking = location.state?.booking || {};
  const navigate = useNavigate();

  // Initialize form state with booking data
  const [formData, setFormData] = useState({
    // These fields will be autofilled from booking data
    // purpose: booking.performanceOccasion || "",
     purpose: booking.performanceOccasion
    ? [{ value: booking.performanceOccasion, label: booking.performanceOccasion }]
    : [],
    performanceDate: booking.performanceDate
      ? new Date(booking.performanceDate).toISOString().split("T")[0]
      : "",
    typeOfOrganization: booking.organisation || "",
    // location: booking.city || "",
    languages: booking.language ? [booking.language] : [],
    // artType: booking.artType || "",
    // artCategory: booking.artCategory || "",
    artType: [],         // pehle add kiya
  artCategory: [],     // ab ye bhi array
  otherArtType: "",
  otherArtCategory: "",
   location: booking.city
    ? [{ value: booking.city, label: booking.city }]
    : [], 
    otherRequirements: booking.requirements || "",
    contactPersonName: booking.name || "",
    contactPersonNumber: booking.contactNumber || "",
    contactEmail: booking.email || "",

    // These fields will remain empty by default
    otherEventName: "",
    description: "",
    startTime: "",
    applicationPeriod: { end: "" },
    budget: "",
    performanceDuration: "",
    otherArtType: "",
    otherArtCategory: "",
    artName: "",
    theme: "",
    mediaType: "",
    otherMediaType: "",
    customization: "",
    requiredArtists: "",
    artistLevel: "",
    otherArtistLevel: "",
    // artistLocation: "",
      artistLocation: booking.artistLocation
    ? [{ value: booking.artistLocation, label: booking.artistLocation }]
    : [],
  otherArtistLocation: "",
    otherArtistLocation: "",
    audienceSize: "",
    audienceProfile: "",
    venue: "",
    otherVenue: "",
    facilities: "",
    otherFacilities: "",
    perksBenefits: "",
  });

  // Helper function to map dropdown values between forms
  const mapDropdownValue = (value, options) => {
    if (!value) return "";

    // Try exact match first
    if (options.includes(value)) return value;

    // Try case-insensitive match
    const lowerValue = value.toLowerCase();
    const matchedOption = options.find((opt) => opt.toLowerCase() === lowerValue);
    if (matchedOption) return matchedOption;

    // Try partial match
    const partialMatch = options.find(
      (opt) =>
        value.toLowerCase().includes(opt.toLowerCase()) ||
        opt.toLowerCase().includes(value.toLowerCase())
    );

    return partialMatch || value; // Return original if no match found
  };

  // State for conditional rendering
  const [showOtherEventInput, setShowOtherEventInput] = useState(false);
  const [showAdditionalFacilitiesInput, setShowAdditionalFacilitiesInput] = useState(false);
  const [showAdditionalVenueInput, setShowAdditionalVenueInput] = useState(false);
  const [showAdditionalArtTypeInput, setShowAdditionalArtTypeInput] = useState(false);
  const [showAdditionalArtCategoryInput, setShowAdditionalArtCategoryInput] = useState(false);
  const [showAdditionalInputother, setShowAdditionalInputother] = useState(false);
  const [showAdditionalmedia, setShowAdditionalmedia] = useState(false);
  const [showAdditionallevel, setShowAdditionallevel] = useState(false);
  const [showAdditionallocation, setShowAdditionallocation] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [uploadTab, setUploadTab] = useState(1);
  const [csvData, setCsvData] = useState("");

  // Language selection state
  const [languagesoptions, setLanguagesOptions] = useState(
    booking.language ? [{ value: booking.language, label: booking.language }] : []
  );
  const [anyLanguage, setAnyLanguage] = useState("");

  const languageOptions = [
    { value: "Assamese", label: "Assamese" },
    { value: "Bengali", label: "Bengali" },
    { value: "Bhili", label: "Bhili" },
    { value: "Bhojpuri", label: "Bhojpuri" },
    { value: "Dogri", label: "Dogri" },
    { value: "Garhwali", label: "Garhwali" },
    { value: "Gujarati", label: "Gujarati" },
    { value: "Haryanvi", label: "Haryanvi" },
    { value: "Hindi", label: "Hindi" },
    { value: "Kannada", label: "Kannada" },
    { value: "Kashmiri", label: "Kashmiri" },
    { value: "Khasi", label: "Khasi" },
    { value: "Kokborok", label: "Kokborok" },
    { value: "Konkani", label: "Konkani" },
    { value: "Kumaoni", label: "Kumaoni" },
    { value: "Maithili", label: "Maithili" },
    { value: "Malayalam", label: "Malayalam" },
    { value: "Manipuri", label: "Manipuri" },
    { value: "Marathi", label: "Marathi" },
    { value: "Mizo (Lushai)", label: "Mizo (Lushai)" },
    { value: "Nepali", label: "Nepali" },
    { value: "Odia", label: "Odia" },
    { value: "Punjabi", label: "Punjabi" },
    { value: "Rajasthani", label: "Rajasthani" },
    { value: "Santali", label: "Santali" },
    { value: "Sindhi", label: "Sindhi" },
    { value: "Tamil", label: "Tamil" },
    { value: "Telugu", label: "Telugu" },
    { value: "Tulu", label: "Tulu" },
    { value: "Urdu", label: "Urdu" },
    { value: "English", label: "English" },
    { value: "Spanish", label: "Spanish" },
    { value: "French", label: "French" },
    { value: "German", label: "German" },
    { value: "Italian", label: "Italian" },
    { value: "Portuguese", label: "Portuguese" },
    { value: "Chinese (Simplified)", label: "Chinese (Simplified)" },
    { value: "Japanese", label: "Japanese" },
    { value: "Korean", label: "Korean" },
    { value: "Russian", label: "Russian" },
    { value: "Any Other", label: "Any Other" },
    { value: "N/A", label: "N/A" },
  ];

  const multiSectionHandle = (e) => {
    e.preventDefault();
    if (!anyLanguage || !anyLanguage.trim()) return;
    // create a new array (don't mutate state directly)
    const newOptions = [...languagesoptions.filter((it) => it.value !== "Any Other"), { value: anyLanguage.trim(), label: anyLanguage.trim() }];
    setLanguagesOptions(newOptions);
    setAnyLanguage("");
  };

  const token = localStorage.getItem("accessToken");

  // const inputChangeHandlerother = (e) => {
  //   setFormData((prevState) => {
  //     if (e.target.name === "purpose") {
  //       if (e.target.value === "Any other") {
  //         setShowAdditionalInputother(true);
  //       } else {
  //         setShowAdditionalInputother(false);
  //       }
  //     }

  //     return { ...prevState, [e.target.name]: e.target.value };
  //   });
  // };

const inputChangeHandlerother = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};


  const handlePurposeChange = (selected) => {
  const selectedArr = selected || [];

  setFormData((prev) => ({
    ...prev,
    purpose: selectedArr, // array of {value,label}
  }));

  const hasAnyOther = selectedArr.some((opt) => opt.value === "Any other");
  setShowOtherEventInput(hasAnyOther);
};


  // const inputChangeHandlerTypeart = (e) => {
  //   setFormData((prevState) => {
  //     if (e.target.name === "artType") {
  //       if (e.target.value === "Other") {
  //         setShowAdditionalArtTypeInput(true);
  //       } else {
  //         setShowAdditionalArtTypeInput(false);
  //       }
  //     }

  //     return { ...prevState, [e.target.name]: e.target.value };
  //   });
  // };

  const inputChangeHandlerTypeart = (selected) => {
  const selectedArr = selected || [];

  setFormData((prev) => ({
    ...prev,
    artType: selectedArr, // array of {value,label}
  }));

  const hasOther = selectedArr.some((opt) => opt.value === "Other");
  setShowAdditionalArtTypeInput(hasOther);
};

  // const inputChangeHandlerCategoryart = (e) => {
  //   setFormData((prevState) => {
  //     if (e.target.name === "artCategory") {
  //       if (e.target.value === "Other") {
  //         setShowAdditionalArtCategoryInput(true);
  //       } else {
  //         setShowAdditionalArtCategoryInput(false);
  //       }
  //     }

  //     return { ...prevState, [e.target.name]: e.target.value };
  //   });
  // };

  const inputChangeHandlerCategoryart = (selected) => {
  const selectedArr = selected || [];

  setFormData((prev) => ({
    ...prev,
    artCategory: selectedArr, // array of {value,label}
  }));

  const hasOther = selectedArr.some((opt) => opt.value === "Other");
  setShowAdditionalArtCategoryInput(hasOther);
};


  const inputChangeHandlermedia = (e) => {
    setFormData((prevState) => {
      if (e.target.name === "mediaType") {
        if (e.target.value === "Other") {
          setShowAdditionalmedia(true);
        } else {
          setShowAdditionalmedia(false);
        }
      }

      return { ...prevState, [e.target.name]: e.target.value };
    });
  };



const allCities = Object.values(indianStatesAndCities).flat(); // ES2019+
const locationOptions = allCities.map((city) => ({
  value: city,
  label: city,
}));



  const inputChangeHandlerlevel = (e) => {
    setFormData((prevState) => {
      if (e.target.name === "artistLevel") {
        if (e.target.value === "Other") {
          setShowAdditionallevel(true);
        } else {
          setShowAdditionallevel(false);
        }
      }
      return { ...prevState, [e.target.name]: e.target.value };
    });
  };


const handleArtistLocationChange = (selected) => {
  const selectedArr = selected || [];

  setFormData((prev) => ({
    ...prev,
    artistLocation: selectedArr,  // array of {value,label}
  }));

  const hasOther = selectedArr.some((opt) => opt.value === "Other");
  setShowAdditionallocation(hasOther);
};



  const handleLocationChange = (selected) => {
  const selectedArr = selected || [];

  setFormData((prev) => ({
    ...prev,
    location: selectedArr,   // array of {value,label}
  }));
};

  const inputChangeHandlerlocation = (e) => {
    setFormData((prevState) => {
      if (e.target.name === "artistLocation") {
        if (e.target.value === "Other") {
          setShowAdditionallocation(true);
        } else {
          setShowAdditionallocation(false);
        }
      }

      return { ...prevState, [e.target.name]: e.target.value };
    });
  };




  const locationSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: "50px",
    borderRadius: "10px",
    borderColor: "rgba(0,0,0,0.4)",
    boxShadow: "none",
    fontFamily: "Poppins",
    fontSize: "16px",
  }),
  menu: (base) => ({
    ...base,
    fontFamily: "Poppins",
    fontSize: "16px",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "16px",
    padding: "8px 12px",
    color: state.isSelected ? "#fff" : "#000",
    backgroundColor: state.isSelected ? "#AD2F3B" : "#fff",
    ":hover": {
      backgroundColor: "#f5f5f5",
      color: "#000",
    },
  }),
};

  const handleAddBulkOpportunity = async () => {
      if (!csvData.trim()) return toast.warning("Please paste CSV data");
      const toastId = toast.loading("Processing bulk upload...");
      try {
          // const lines = csvData.trim().split("\n");
          // const artists = lines.map(line => {
          //     const [userId, purpose,description,location,languages,budget,performanceDate,typeOfProduct,typeOfOrganization,startTime,performanceDuration,applicationPeriodStart,applicationPeriodEnd,artType,artCategory,artName,theme,mediaType,customization,requiredArtists,artistLevel,artistLocation,audienceSize,audienceProfile,venue,facilities,otherRequirements,contactPersonName,contactPersonNumber,contactEmail,active,isBlocked] = line.split(",").map(s => s.trim());
          //     return { purpose,description,location,languages,budget,performanceDate,typeOfProduct,typeOfOrganization,startTime,performanceDuration,applicationPeriodStart,applicationPeriodEnd,artType,artCategory,artName,theme,mediaType,customization,requiredArtists,artistLevel,artistLocation,audienceSize,audienceProfile,venue,facilities,otherRequirements,contactPersonName,contactPersonNumber,contactEmail,active,isBlocked };
          // });
          
          if (csvData.length === 0) throw new Error("No valid data to upload.");

          const response = await fetch(`${BASE_URL}/admin/users/add-bulk-opportunities`, {
              method: "POST",
              headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
              body: JSON.stringify({ csvData })
          });
          const result = await response.json();
          
          if (response.status !== 200){
            throw new Error(result.message || "Bulk add failed");
          } 
          
          toast.update(toastId, { render: `Added ${result.count} artists successfully.`, type: "success", isLoading: false, autoClose: 3000 });
          setShowAddModal(false);
          setCsvData("");
          // setTimeout(() => getUser(), 500);
      } catch (error) {
          toast.update(toastId, { render: `Error: ${error.message}`, type: "error", isLoading: false, autoClose: 3000 });
      }
  };

  const inputChangeHandlerVenue = (e) => {
    setFormData((prevState) => {
      if (e.target.name === "venue") {
        if (e.target.value === "Any other") {
          setShowAdditionalVenueInput(true);
        } else {
          setShowAdditionalVenueInput(false);
        }
      }

      return { ...prevState, [e.target.name]: e.target.value };
    });
  };

  const inputChangeHandler = (e) => {
    setFormData((prevState) => {
      // if (e.target.name === "purpose") {
      //   if (e.target.value === "Any other") {
      //     setShowOtherEventInput(true);
      //   } else {
      //     setShowOtherEventInput(false);
      //   }
      // }
      if (e.target.name === "start" || e.target.name === "end") {
        const applicationPeriod = {
          [e.target.name]: e.target.value,
        };

        return {
          ...prevState,
          applicationPeriod: {
            ...prevState.applicationPeriod,
            ...applicationPeriod,
          },
        };
      }

      return { ...prevState, [e.target.name]: e.target.value };
    });
  };

  const inputChangeHandlerFacilities = (e) => {
    setFormData((prevState) => {
      if (e.target.name === "facilities") {
        if (e.target.value === "Any other") {
          setShowAdditionalFacilitiesInput(true);
        } else {
          setShowAdditionalFacilitiesInput(false);
        }
      }

      return { ...prevState, [e.target.name]: e.target.value };
    });
  };

  const submitHandler = async (e) => {
  e.preventDefault();
  const languages = languagesoptions.map((l) => l.value);

  // 👇 force default mediaType since you don't want it in the form
  // const payload = { 
  //   ...formData, 
  //   languages: languages.join(", "),
  //   mediaType: "Live" 
  // };

// const payload = {
//   ...formData,
//   languages: languages.join(", "),
//   artType: Array.isArray(formData.artType)
//     ? formData.artType.map((o) => o.value).join(", ")
//     : formData.artType,
//   artCategory: Array.isArray(formData.artCategory)
//     ? formData.artCategory.map((o) => o.value).join(", ")
//     : formData.artCategory,
//   mediaType: "Live",
// };



const payload = {
  ...formData,
  languages: languages.join(", "),
  artType: formData.artType.map((o) => o.value).join(", "),
  artCategory: formData.artCategory.map((o) => o.value).join(", "),
  purpose: formData.purpose.map((o) => o.value).join(", "),
  location: formData.location.map((o) => o.value).join(", "),
  artistLocation: formData.artistLocation.map((o) => o.value).join(", "),
  mediaType: "Live",
};


  const toastId = toast.loading("Loading...");

  try {
    const response = await makeAuthenticatedPOSTRequest(
      `${BASE_URL}/admin/postopps`,
      payload,
      token
    );
    console.log(response);
    if (!response.errors) {
      toast.success("Successfully uploaded");
      setFormData((prevState) => ({
        ...prevState,
        applicationPeriod: {
          start: "",
          end: "",
        },
      }));
      setFormData((prevState) => ({
        ...prevState,
        artNature: "",
        location: "",
        description: "",
      }));
      navigate("/opportunity");
    } else {
      console.log(response);
      toast.error("Please provide all the required fields");
    }
  } catch (error) {
    console.log(error);
    toast.error("something went wrong , please try again");
  }
  toast.dismiss(toastId);
};


  const purposeOfPerformance = [
    "Annual / Foundation Day",
    "Conference/ Workshop/ Training",
    "Employee Engagement",
    "Family functions",
    "National/ State Day Celebration",
    "Office Functions",
    "Performance for hotel guests",
    "Product Launch",
    "Special Day – Marriage, Anniversary",
    "Special Events",
    "Any other",
  ];

  const purposeOptions = purposeOfPerformance.map((p) => ({
  value: p,
  label: p,
}));

  const ArtNames = [
    "Bharatanatyam",
    "Bihu",
    "Chhau",
    "Dandiya Raas",
    "Dollu Kunitha",
    "Dumhal",
    "Garba",
    "Gaur Dance",
    "Giddha",
    "Gotipua",
    "Jhumar",
    "Kacchi Ghodi",
    "Kalbelia",
    "Karakattam",
    "Kathak",
    "Kathakali",
    "Kathakar",
    "Koli",
    "Kuchipudi",
    "Lavani",
    "Manipuri",
    "Mayurbhanj Chhau",
    "Mohiniyattam",
    "Odissi",
    "Raas Leela",
    "Sattriya",
    "Tamasha",
    "Tera Tali",
    "Thang-Ta",
    "Yakshagana",
    "Dhrupad",
    "Khayal",
    "Thumri",
    "Tappa",
    "Ghazal",
    "Qawwali",
    "Kriti",
    "Varnam",
    "Tillana",
    "Ragamalika",
    "Javali",
    "Swarajati",
    "Bhajans",
    "Kirtan",
    "Sufi Music",
    "Abhangas",
    "Shabad Kirtan (Sikh)",
    "Bansuri",
    "Dilruba",
    "Dholak",
    "Ektara",
    "Esraj",
    "Flute (Bansuri)",
    "Ghatam",
    "Harmonium",
    "Jal Tarang",
    "Mridangam",
    "Nadaswaram",
    "Pakhawaj",
    "Ravanahatha",
    "Sarangi",
    "Sarod",
    "Santoor",
    "Shehnai",
    "Sitar",
    "Tabla",
    "Tanpura",
    "Tumbi",
    "Veena",
    "Bhavai",
    "Bhand Pather",
    "Jatra",
    "Koodiyattam",
    "Mudiyettu",
    "Nautanki",
    "Pandavani",
    "Pothu Koothu",
    "Ramlila",
    "Ram Lila",
    "Ras Leela",
    "Sattriya",
    "Tamaasha",
    "Therukoothu",
    "Yakshagana",
  ];

  const venueTypes = [
    "Banquette Hall",
    "Classroom",
    "Corporate",
    "Hotel",
    "Open Ground",
    "Private House",
    "Theater",
    "Training Center",
    "Any other",
  ];
  const typeart = ["Folk", "Classical", "Fusion", "Other"];
  const artTypeOptions = typeart.map((t) => ({
  value: t,
  label: t,
}));
  const artCategory = ["Dance", "Song", "Music", "Theater", "Other"];
  const artCategoryOptions = artCategory.map((t) => ({
  value: t,
  label: t,
}));
  const performanceFacilitiesaArr = [
    "Accommodation",
    "Food",
    "Light",
    "Local Travel",
    "Musical Instruments",
    "Outstation Travel",
    "Photography",
    "Sound",
    "Stage",
    "Video",
    "Any other",
  ];
  const media = ["Live", "Recorded", "PartLive", "Other"];
  const artistLevel = [
    "international",
    "National",
    "district",
    "taluka",
    "local",
    "Other",
  ];


  return (
    <>
      <AdminNavbar />
      <div className="ArtistOpportunities_Page">  
        <div className="opportunity_container">
          <div onClick={()=> navigate('/Opportunity')} style={{alignSelf:"start", fontWeight:"500", fontSize:"x-large", color:"#ad2020", cursor:"pointer"}}>
            <FaArrowCircleLeft /> 
          </div>
          <div className="" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" , width:"90%"}}>
            <strong style={{ marginTop: "3%", color: "#AD2F3B", fontSize: "35px" }}>
              Create Opportunity
            </strong>
            <button style={{ backgroundColor: "#AD2F3B", color: "white", border: "none", padding: "10px 20px", fontWeight: "semi-bold", borderRadius: "5px", cursor: "pointer" }} onClick={()=> setShowAddModal(true)}>
              + Bulk Upload
            </button>
          </div>

          <div className="ArtistOpportunities_Page_Infoform">
            <form onSubmit={submitHandler}>
              <div className="ArtistOpportunities_Page_Infoform_Contentone">
                <div className="opp_top">
                  {/* <div className="ArtistOpportunities_Page_Infoform_inputfield_Name">
                    <label style={{ fontSize: "18px" }}>
                      <strong>Name of Performance*</strong>
                    </label>

                    <select
                      required
                      name="purpose"
                      value={formData.purpose}
                      onChange={inputChangeHandler}
                      style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}
                    >
                      <option value="" disabled hidden>
                        Select purpose
                      </option>
                      {purposeOfPerformance.map((item, index) => (
                        <option value={item} key={index}>
                          {item}
                        </option>
                      ))}
                    </select>

                    {formData.purpose === "Any other" && (
                      <input
                        type="text"
                        name="otherEventName"
                        placeholder="Enter performance name"
                        value={formData.otherEventName}
                        onChange={inputChangeHandler}
                        style={{ width: "100%", height: "50px", borderRadius: "10px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}
                      />
                    )}
                  </div> */}

                  <div className="ArtistOpportunities_Page_Infoform_inputfield_Name">
  <label style={{ fontSize: "18px" }}>
    <strong>Name of Performance*</strong>
  </label>

  <Select
    isMulti
    name="purpose"
    options={purposeOptions}
    value={formData.purpose}
    onChange={handlePurposeChange}
    placeholder="Select purpose"
    styles={locationSelectStyles}
  />

  {showOtherEventInput && (
    <input
      type="text"
      name="otherEventName"
      placeholder="Enter performance name"
      value={formData.otherEventName}
      onChange={inputChangeHandlerother}
      style={{
        width: "100%",
        height: "50px",
        borderRadius: "10px",
        boxShadow: "#a2a2a2 0px 3px",
        marginTop: "10px",
      }}
    />
  )}
</div>


                  <div className="ArtistOpportunities_Page_Infoform_inputfield" style={{ width: "90%" }}>
                    <label>
                      <strong>Description</strong>
                    </label>
                    <textarea
                      required
                      name="description"
                      value={formData?.description}
                      onChange={inputChangeHandler}
                      type="text"
                      style={{ width: "100%", height: "65px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}
                      placeholder="Enter art Description"
                    />
                  </div>

                  <div className="ArtistOpportunities_Page_Infoform_inputfield">
                    <label>
                      <strong>Date of Performance*</strong>
                    </label>
                    <input
                      required
                      value={formData?.performanceDate}
                      name="performanceDate"
                      onChange={inputChangeHandler}
                      type="date"
                      min={new Date().toISOString().split("T")[0]}
                      placeholder="Enter event date"
                      style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}
                    />
                  </div>

                  <div className="ArtistOpportunities_Page_Infoform_inputfield">
                    <label>
                      <strong>Starting Time of Performance (hrs)*</strong>
                    </label>
                    <input
                      required
                      onChange={inputChangeHandler}
                      value={formData?.startTime}
                      name="startTime"
                      type="text"
                      placeholder="Enter Performance Time"
                      style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}
                    />
                  </div>

                  <div className="opp_top">
                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Enter Type of Organization</strong>
                      </label>
                      <input
                        onChange={inputChangeHandlerother}
                        name="typeOfOrganization"
                        type="text"
                        placeholder="Enter Organization Type"
                        value={formData.typeOfOrganization}
                        style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}
                      />
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Application Last Date*</strong>
                      </label>
                      <input
                        required
                        onChange={inputChangeHandler}
                        name="end"
                        value={formData?.applicationPeriod?.end}
                        type="date"
                        min={new Date().toISOString().split("T")[0]}
                        placeholder="Enter application last date"
                        style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}
                      />
                    </div>

                    <div style={{ margin: "20px", width: "90%", fontSize: "30px", color: "#AD2F3B", fontWeight: "600" }}>
                      Performance
                    </div>


{/* 
                   <div className="ArtistOpportunities_Page_Infoform_inputfield">
                     <label><strong>Location of Performance</strong></label>
                         <Select
                           name="location"
                                  value={
                                  formData.location?{ value: formData.location, label: formData.location }: null}
                                  onChange={(selected) =>
                                  setFormData((prev) => ({ ...prev, location: selected?.value || "" }))
                                   }
                                   options={locationOptions}
                                   placeholder="Search and select location" isClearable/>
                                   </div> */}

                   <div className="ArtistOpportunities_Page_Infoform_inputfield">
  <label>
    <strong>Location of Performance*</strong>
  </label>

  <Select
    isMulti
    name="location"
    value={formData.location}
    onChange={handleLocationChange}
    options={locationOptions}
    placeholder="Search and select location"
    isClearable
    styles={locationSelectStyles}
  />
</div>



                    

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Language of Performance*</strong>
                      </label>
                      <Select
                        defaultValue={languagesoptions}
                        value={languagesoptions}
                        isMulti
                        onChange={setLanguagesOptions}
                        options={languageOptions}
                        placeholder="Select languages"
                      />
                    </div>

                    {languagesoptions?.find((e) => e.value === "Any Other") !== undefined ? (
                      <>
                        <div className="BasicProfile_inputfield">
                          <label htmlFor="firstName">Enter Your Language</label>
                          <input onChange={(e) => setAnyLanguage(e.target.value)} name="firstName" value={anyLanguage} type="text"></input>
                          <button
                            name="Language"
                            onClick={multiSectionHandle}
                            style={{ background: "red", marginTop: "10px", width: "40px", height: "40px", borderRadius: "50%", border: "none", fontSize: "25px", color: "#fff" }}
                          >
                            +
                          </button>
                        </div>
                      </>
                    ) : null}

                    {/* <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Approx. Budget for Performance*</strong>
                      </label>
                      <select required onChange={inputChangeHandler} value={formData?.budget} name="budget" style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select budget
                        </option>
                        <option value="24000">Below 25000</option>
                        <option value="35000">25000-50000</option>
                        <option value="70000">50000-100000</option>
                        <option value="200000">100000-250000</option>
                        <option value="800000">250000-1000000</option>
                        <option value="1200000">Above 1000000</option>
                      </select>
                    </div> */}


                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
  <label>
    <strong>Approx. Budget for Performance*</strong>
  </label>
  <input
    required
    name="budget"
    type="number"
    value={formData.budget || ""}
    onChange={(e) =>
      setFormData((prev) => ({ ...prev, budget: e.target.value }))
    }
    placeholder="Enter budget amount (e.g. 50000)"
    style={{
      width: "100%",
      height: "50px",
      boxShadow: "#a2a2a2 0px 3px",
      marginTop: "10px",
      borderRadius: "10px",
      padding: "10px",
      border: "1px solid rgba(0,0,0,0.4)",
    }}
  />
</div>


                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Duration of Performance (hrs)*</strong>
                      </label>
                      <input required onChange={inputChangeHandler} value={formData?.performanceDuration} name="performanceDuration" type="text" placeholder="Enter Performance Duration" style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                    </div>

                    {/* <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Type of Art*</strong>
                      </label>
                      <select required value={formData?.artType} name="artType" onChange={inputChangeHandlerTypeart} style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select
                        </option>
                        {typeart?.map((item, index) => (
                          <option value={item} key={index}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
  <label>
    <strong>Type of Art*</strong>
  </label>

  <Select
    isMulti
    name="artType"
    options={artTypeOptions}
    value={formData.artType}
    onChange={inputChangeHandlerTypeart}
    placeholder="Select"
    styles={locationSelectStyles}   // tumhare file me already defined hai
  />
</div>

{showAdditionalArtTypeInput && (
  <div className="ArtistOpportunities_Page_Infoform_inputfield">
    <label>
      <strong>Other Type of Art</strong>
    </label>
    <input
      name="otherArtType"
      type="text"
      value={formData.otherArtType}
      onChange={(e) =>
        setFormData((prev) => ({ ...prev, otherArtType: e.target.value }))
      }
      placeholder="Enter other type of art"
      style={{
        width: "100%",
        height: "50px",
        boxShadow: "#a2a2a2 0px 3px",
        marginTop: "10px",
      }}
    />
  </div>
)}


                    {showAdditionalArtTypeInput && (
                      <div className="ArtistOpportunities_Page_Infoform_inputfield">
                        <label>
                          <strong>Other Type of Art</strong>
                        </label>
                        <input onChange={inputChangeHandlerTypeart} name="otherArtType" type="text" placeholder="Enter other type of art " style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                      </div>
                    )}


  


                    {/* <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Category of Art*</strong>
                      </label>
                      <select required onChange={inputChangeHandlerCategoryart} name="artCategory" value={formData?.artCategory} style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select
                        </option>
                        {artCategory?.map((item, index) => (
                          <option value={item} key={index}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    {showAdditionalArtCategoryInput && (
                      <div className="ArtistOpportunities_Page_Infoform_inputfield">
                        <label>
                          <strong>Other Category of Art</strong>
                        </label>
                        <input onChange={inputChangeHandlerCategoryart} name="otherArtType" type="text" placeholder="Enter other Category of art " style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                      </div>
                    )} */}

                        <div className="ArtistOpportunities_Page_Infoform_inputfield">
  <label>
    <strong>Category of Art*</strong>
  </label>

  <Select
    isMulti
    name="artCategory"
    options={artCategoryOptions}
    value={formData.artCategory}
    onChange={inputChangeHandlerCategoryart}
    placeholder="Select"
    styles={locationSelectStyles}
  />
</div>

{showAdditionalArtCategoryInput && (
  <div className="ArtistOpportunities_Page_Infoform_inputfield">
    <label>
      <strong>Other Category of Art</strong>
    </label>
    <input
      name="otherArtCategory"
      type="text"
      value={formData.otherArtCategory}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          otherArtCategory: e.target.value,
        }))
      }
      placeholder="Enter other Category of art"
      style={{
        width: "100%",
        height: "50px",
        boxShadow: "#a2a2a2 0px 3px",
        marginTop: "10px",
      }}
    />
  </div>
)}



                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Name of Art*</strong>
                      </label>
                      <select  value={formData?.artName} name="artName" onChange={inputChangeHandler} style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select
                        </option>
                        {ArtNames?.map((item, index) => (
                          <option value={item} key={index}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Theme of Performance</strong>
                      </label>
                      <input required onChange={inputChangeHandler} value={formData?.theme} name="theme" type="text" placeholder="Theme for Performmance/Event" style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Live/Recorded/Part Live</strong>
                      </label>
                      <select onChange={inputChangeHandlermedia} name="mediaType" style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select
                        </option>
                        {media?.map((item, index) => (
                          <option value={item} key={index}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    {showAdditionalmedia && (
                      <div className="ArtistOpportunities_Page_Infoform_inputfield">
                        <label>
                          <strong>Other Type of Media</strong>
                        </label>
                        <input onChange={inputChangeHandlermedia} name="othermediaType" type="text" placeholder="Enter other type of media " style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                      </div>
                    )}

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Need Customized/ curated Performance</strong>
                      </label>
                      <select onChange={inputChangeHandler} name="customization" style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select
                        </option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>

                    <div className="artist_data_opp" style={{ fontSize: "30px", color: "#AD2F3B", fontWeight: "600" }}>
                      Artist
                      <div className="art_two" style={{ width: "100%" }}>
                        {/* <div className="ArtistOpportunities_Page_Infoform_inputfield_No">
                          <label>
                            <strong>No. of Required Artist*</strong>
                          </label>
                          <select required value={formData?.requiredArtists} name="requiredArtists" onChange={inputChangeHandler} style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                            <option value="" disabled hidden>
                              Select
                            </option>
                            <option value="1">1</option>
                            <option value="3">2-5</option>
                            <option value="7">5-10</option>
                            <option value="20">10-50</option>
                            <option value="60">Above 50</option>
                          </select>
                        </div> */}

                        <div className="ArtistOpportunities_Page_Infoform_inputfield_No">
  <label>
    <strong>No. of Required Artist*</strong>
  </label>
 <input
  required
  type="text"
  name="requiredArtists"
  value={formData?.requiredArtists}
  onChange={inputChangeHandler}
  placeholder="Enter number"
  style={{
    width: "100%",
    height: "50px",
    boxShadow: "#a2a2a2 0px 3px",
    marginTop: "10px",
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.4)",
    padding: "10px",
    color: "black",      // <--- Added this
    fontSize: "16px"     // <--- Added this
  }}
/>
</div>

                        <div className="ArtistOpportunities_Page_Infoform_inputfield_No">
                          <label>
                            <strong>Level of Artist*</strong>
                          </label>
                          <select required onChange={inputChangeHandlerlevel} value={formData?.artistLevel} name="artistLevel" style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                            <option value="" disabled hidden>
                              Select
                            </option>
                            {artistLevel?.map((item, index) => (
                              <option value={item} key={index}>
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {showAdditionallevel && (
                        <div className="ArtistOpportunities_Page_Infoform_inputfield">
                          <label>
                            <strong>Enter Level of Artist</strong>
                          </label>
                          <input onChange={inputChangeHandlerlevel} name="otherArtType" type="text" placeholder="Enter Level of Artist " style={{ width: "490px", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                        </div>
                      )}

                      {/* <div className="ArtistOpportunities_Page_Infoform_inputfield_No">
                        <label>
                          <strong>Location of Artist*</strong>
                        </label>
                        <select onChange={inputChangeHandlerlocation} name="artistLocation" value={formData?.artistLocation} required style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                          <option value="" disabled hidden>
                            Select
                          </option>
                          {artistLocation?.map((item, index) => (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div> */}



                      
<div className="ArtistOpportunities_Page_Infoform_inputfield">
  <label>
    <strong>Location of Artist*</strong>
  </label>
  <Select
    isMulti
    name="artistLocation"
    value={formData.artistLocation}
    onChange={handleArtistLocationChange}
    options={locationOptions}
    placeholder="Search and select location"
    isClearable
    styles={locationSelectStyles}
  />
</div>

{showAdditionallocation && (
  <div className="ArtistOpportunities_Page_Infoform_inputfield">
    <label>
      <strong>Other Location of Artist</strong>
    </label>
    <input
      name="otherArtistLocation"
      type="text"
      value={formData.otherArtistLocation}
      onChange={inputChangeHandlerother}
      placeholder="Enter other artist location"
      style={{
        width: "100%",
        height: "50px",
        boxShadow: "#a2a2a2 0px 3px",
        marginTop: "10px",
      }}
    />
  </div>
)}


                      {showAdditionallocation && (
                        <div className="ArtistOpportunities_Page_Infoform_inputfield">
                          <label>
                            <strong>Enter Location</strong>
                          </label>
                          <input onChange={inputChangeHandlerlocation} name="otherArtistLocation" type="text" placeholder="Enter Artist Location " style={{ width: "490px", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                        </div>
                      )}
                    </div>

                    <div style={{ margin: "20px", width: "90%", fontSize: "30px", color: "#AD2F3B", fontWeight: "600" }}>
                      Audience & Venue
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Size of Audience*</strong>
                      </label>
                      <select onChange={inputChangeHandler} name="audienceSize" value={formData?.audienceSize} required style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select
                        </option>
                        <option value="20">Below 25</option>
                        <option value="35">25-50</option>
                        <option value="70">50-100</option>
                        <option value="300">100-500</option>
                        <option value="800">500-1000</option>
                        <option value="1200">Above 1000</option>
                      </select>
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Profile of Audience*</strong>
                      </label>
                      <select onChange={inputChangeHandler} name="audienceProfile" value={formData?.audienceProfile} required style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select
                        </option>
                        <option value="Hotel inhouse Guests ">Hotel inhouse Guests</option>
                        <option value="Professional/ Executives">Professional/ Executives</option>
                        <option value="Students">Students</option>
                        <option value="Family Guests">Family Guests</option>
                      </select>
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Venue of Performance*</strong>
                      </label>
                      <select onChange={inputChangeHandlerVenue} name="venue" value={formData?.venue} required style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select
                        </option>
                        {venueTypes?.map((item, index) => (
                          <option value={item} key={index}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    {showAdditionalVenueInput && (
                      <div className="ArtistOpportunities_Page_Infoform_inputfield">
                        <label>
                          <strong>Other Venue</strong>
                        </label>
                        <input onChange={inputChangeHandler} name="otherVenue" type="text" placeholder="Enter venue information" style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                      </div>
                    )}

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Performance Facilities*</strong>
                      </label>
                      <select onChange={inputChangeHandlerFacilities} name="facilities" value={formData?.facilities} required style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }}>
                        <option value="" disabled hidden>
                          Select
                        </option>
                        {performanceFacilitiesaArr?.map((item, index) => (
                          <option value={item} key={index}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    {showAdditionalFacilitiesInput && (
                      <div className="ArtistOpportunities_Page_Infoform_inputfield">
                        <label>
                          <strong>Other Facilities</strong>
                        </label>
                        <input onChange={inputChangeHandler} name="otherFacilities" type="text" placeholder="Enter performance facilities" style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                      </div>
                    )}

                    <div className="ArtistOpportunities_Page_Infoform_inputfield textareafield" style={{ width: "90%" }}>
                      <label>
                        <strong>Other Requirement:</strong>
                      </label>
                      <textarea onChange={inputChangeHandler} name="otherRequirements" value={formData?.otherRequirements} style={{ height: "60px", resize: "none", width: "100%", boxShadow: "#a2a2a2 0px 3px" }} placeholder="Enter Any Other requirements"></textarea>
                    </div>

                    <div style={{ margin: "20px", width: "90%", fontSize: "30px", color: "#AD2F3B", fontWeight: "600" }}>
                      Contact
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Name</strong>
                      </label>
                      <input name="Name" type="text" placeholder="Name of User" onChange={(e) => setFormData({ ...formData, contactPersonName: e.target.value })} style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Contact Number</strong>
                      </label>
                      <input name="Name" type="text" placeholder="Contact Number" onChange={(e) => setFormData({ ...formData, contactPersonNumber: e.target.value })} style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Email</strong>
                      </label>
                      <input name="Email" type="text" placeholder="Email of User" onChange={(e) => setFormData({ ...formData, contactEmail: e.target.value })} style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                    </div>

                    <div className="ArtistOpportunities_Page_Infoform_inputfield">
                      <label>
                        <strong>Perks & Benefits</strong>
                      </label>
                      <input name="Perks_Benefits" type="text" placeholder="" onChange={inputChangeHandler} style={{ width: "100%", height: "50px", boxShadow: "#a2a2a2 0px 3px", marginTop: "10px" }} />
                    </div>

                  </div>

                  <div className="ArtistOpportunities_Page_Infoform_btns" style={{ textAlign: "center", width: "100%" }}>
                    <button type="Submit" style={{ cursor: "pointer" }}>
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {showAddModal && (
          <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
              <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-header"><h3>Add New Opportnities</h3><IoClose className="modal-close" onClick={() => setShowAddModal(false)} /></div>
                  
                  <div className="modal-form">
                      <div className="form-group"><label>Paste CSV Data</label><textarea className="csv-textarea" placeholder='Title, Description, Date of Performance, Time of Performance, Application Deadline, Location, "[Languages]", Budget, Duration, "[Type of Art]", "[Category of Art]", Name of Art, Theme of Performance, Live/Recorded, Curated Performance, No. of Artist, Level of Artist, Location of Artist, Size of Audience, Profile, Venue, Facilities, Requirements' value={csvData} onChange={(e) => setCsvData(e.target.value)} rows={8} /></div>
                      <p className="csv-note">Each line must contain values in this exact order: <strong>Title, Description, Date of Performance, Time of Performance, Application Deadline, Location, "[Languages]", Budget, Duration, "[Type of Art]", "[Category of Art]", Name of Art, Theme of Performance, Live/Recorded, Curated Performance, No. of Artist, Level of Artist, Location of Artist, Size of Audience, Profile, Venue, Facilities, Requirements</strong></p>
                      <div className="modal-actions">
                          <button type="button" className="btn-cancel" onClick={() => setShowAddModal(false)}>Cancel</button>
                          <button type="button" className="btn-submit" onClick={handleAddBulkOpportunity}>Add Bulk</button>
                      </div>
                  </div>
              </div>
          </div>
        )}
    </>
  );
}

export default UploadOpportunities;